import {
  Component, ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {PortalBaseComponent} from "../../../../core/components/portal-base/portal-base.component";
import {FormioCustomComponent} from "@formio/angular";
import {PortalPageComponent} from "../../portal-page.component";
import {UserService} from "../../../../core/services/user/user.service";
import {Subscription} from "rxjs";
import {PortalCrumb} from "../../../../core/services/portal/portal-crumb";
import {PortalService} from "../../../../core/services/portal/portal.service";
import { ItemModel } from '@syncfusion/ej2-angular-splitbuttons';
import {$translate} from "../../../../core/services/internationalization/localize.service";
import {MenuEventArgs} from "@syncfusion/ej2-splitbuttons/src/common/common";

@Component({
  selector: 'sb-portal-controls,sb-dynamic-portal-controls',
  templateUrl: './portal-controls.component.html',
  styleUrls: ['./portal-controls.component.scss']
})
export class PortalControlsComponent  extends PortalBaseComponent implements FormioCustomComponent<string>, OnInit, OnDestroy {
  @Input()
  disabled: boolean;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  navigationEventSubscription: Subscription;

  breadcrumb: PortalCrumb[] = [];

  items: ItemModel[] = [
    {
      id: 'Select',
      text: $translate("ng.component.portal-controls.refresh.select-default-dashboard")`Select default dashboard`,
    },
    {
      id: 'Logout',
      text: $translate("ng.component.portal-controls.refresh.logout")`Logout`,
      url: "/logout"
    },
  ];

  constructor(private userService: UserService, public portalService: PortalService, public hostElement: ElementRef) {
    super(portalService, hostElement);
  }

  ngOnInit() {
    super.init();
    this.breadcrumb = this.portalService.getBreadcrumb();
    this.navigationEventSubscription = this.portalService.navigationEvent.subscribe(() => {
      this.breadcrumb = this.portalService.getBreadcrumb();
    });
  }

  ngOnDestroy() {
    super.destroy();
    this.navigationEventSubscription && this.navigationEventSubscription.unsubscribe();
  }

  async refresh() {
  }

  dashboardName() {
    return this.dashboard()?.dashboardName;
  }

  dashboardDescription() {
    return this.dashboard()?.dashboardDescription;
  }

  dashboardRefresh() {
    return this.dashboard()?.dashboardRefresh || 0;
  }

  manualRefresh() {
    this.dashboard().refreshAllComponents(true, 0);
  }

  selectDefault() {
    this.dashboard().displayPageModal(true);
  }

  userName() {
    return this.userService.getFirstName();
  }

  selectRefresh(event) {
    const selectValue = event.target.value;
    this.portalService.getPageForComponent(this)?.setRefresh(Number(selectValue));
  }

  navigate(id: string) {
    this.portalService.navigateViaBreadcrumb(id);
    this.breadcrumb = this.portalService.getBreadcrumb();
  }

  private dashboard(): PortalPageComponent {
    return this.portalService.getPageForComponent(this);
  }

  onSelect($event: MenuEventArgs) {
    if ($event.item.id == 'Select') {
      this.selectDefault();
    }
  }
}
